import { del, get, post, put } from '../../client';
import { shouldLogApiCalls } from '../../config';

export const listCustomFields = async (page_at, page_size, sort_by, sort_order, search_term) => {
    if (shouldLogApiCalls) {
        console.log('List custom fields attempt:', { page_at, page_size, sort_by, sort_order, search_term });
    }
    
    return get(`/custom-field?page_at=${page_at}&page_size=${page_size}`);
}

export const createCustomField = async (data) => {
    return post(`/custom-field`, data);
}

export const updateCustomField = async (id, data) => {
    return put(`/custom-field/${id}`, data);
}

export const deleteCustomField = async (id) => {
    return del(`/custom-field/${id}`);
}